const e=()=>"undefined"!=typeof document;export{e as isBrowser};
